import { format } from 'date-fns';

import { getPlatformLabel } from '@/lib/platforms/identity';

export const PLACEHOLDER_POST_TITLE = 'New draft';

const FILE_NAME_TITLE = /^([^\n]{1,80})\.(avif|gif|heic|jpe?g|m4v|mov|mp4|png|webm|webp)$/i;
const SLUG_TITLE = /^[a-z0-9]+(?:[-_][a-z0-9]+){2,}$/;

export function looksLikeFileName(title: string): boolean {
  const trimmed = title.trim();
  const match = FILE_NAME_TITLE.exec(trimmed);
  if (match && !/[.!?,;:]/.test(match[1].replace(/(?<=\d)\.(?=\d)/g, ''))) return true;
  return SLUG_TITLE.test(trimmed);
}

export function meaningfulPostTitle(title: string | null | undefined): string | null {
  const trimmed = title?.trim();
  if (!trimmed) return null;
  if (trimmed.toLowerCase() === PLACEHOLDER_POST_TITLE.toLowerCase()) return null;
  if (looksLikeFileName(trimmed)) return null;
  return trimmed;
}

function countLabel(count: number, singular: string): string {
  return `${count} ${singular}${count === 1 ? '' : 's'}`;
}

export function untitledPostCue(post: {
  media_urls?: unknown;
  media_type?: string | null;
  platforms?: unknown;
}): string {
  const mediaUrls = Array.isArray(post.media_urls)
    ? post.media_urls.filter((value): value is string => typeof value === 'string')
    : [];
  const mediaCount = mediaUrls.length;
  const hasVideo =
    post.media_type === 'video' || mediaUrls.some((url) => /\.(mp4|mov|m4v|webm)(\?|$)/i.test(url));
  const platforms = Array.isArray(post.platforms)
    ? post.platforms.filter((value): value is string => typeof value === 'string')
    : [];
  const parts: string[] = [];
  if (mediaCount > 0) {
    parts.push(countLabel(mediaCount, hasVideo ? 'video' : 'image'));
  } else {
    parts.push('No caption or media yet');
  }
  if (platforms.length > 0) parts.push(platforms.map(getPlatformLabel).join(', '));
  return parts.join(' · ');
}

export function untitledPostLabel(createdAt?: string | null): string {
  if (!createdAt) return 'Untitled post';
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return 'Untitled post';
  return `Untitled post, ${format(date, 'MMM d')}`;
}

export function candidatePostTitle(post: {
  title?: string | null;
  content?: string | null;
  created_at?: string | null;
}): string {
  const title = meaningfulPostTitle(post.title);
  if (title) return title;
  const firstLine = (post.content ?? '').trim().split('\n')[0]?.trim() ?? '';
  if (firstLine) return firstLine.slice(0, 70);
  return untitledPostLabel(post.created_at);
}
